import './tamimi/style';
import FormStructure from './tamimi/form_structure';

export default FormStructure;